import { postListFetcher } from '@/shared/api/list';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { typeFilter } from './filters';

interface Mark extends ListRow {
  id: number;
  name: string;
  type?: string;
  tags?: Array<{ id: number; title: string }>;
  template?: { url: string; 'mime-type'?: string } | null;
  logo?: { url: string } | null;
  is_active?: number;
}

const LOGO_SIZE = 30;

const config: ListPageConfig<Mark> = {
  queryKey: 'car-marks',
  title: 'Справочник авто',
  boxTitle: 'Марка',
  errorText: 'Ошибка загрузки марок',
  fetchList: postListFetcher('/car/mark/list/'),
  rows: ['marks'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id' },
    { value: 'name', label: 'Поиск по марке' },
  ],
  filters: [typeFilter],
  columns: [
    { header: 'id', sortField: 'id', render: (mark) => mark.id },
    { header: 'Марка', sortField: 'name', render: (mark) => mark.name },
    { header: 'Тип', sortField: 'type_id', render: (mark) => mark.type },
    {
      header: 'Теги',
      sortField: 'type_tags',
      render: (mark) => mark.tags?.map((tag) => tag.title).join(', ') || 'нет данных',
    },
    {
      header: 'Шаблон',
      render: (mark) =>
        mark.template ? (
          <a href={mark.template.url} download>
            {mark.template['mime-type']}
          </a>
        ) : (
          'Нет файла шаблона'
        ),
    },
    {
      header: 'Логотип авто',
      render: (mark) =>
        mark.logo && <img width={LOGO_SIZE} height={LOGO_SIZE} src={mark.logo.url} alt="logo-auto" />,
    },
    { header: 'is active', render: (mark) => mark.is_active },
  ],
};

export const MarksPage = () => <GenericListPage config={config} />;
